import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AlertService } from '../../../services/alert.service';
import { NgClass } from '@angular/common';
import { LoginForm } from '../../components/home-choice/login/login.form';


@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, LoginForm]
})
export class LoginPage implements OnInit {
    protected alert = inject(AlertService);
    protected route = inject(ActivatedRoute);


    isLoading: boolean = false;

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params.notAuthenticated === true) {
                this.alert.error('ERRORS.NOT_AUTHENTICATED');
            }
        });
    }


    public changeFormLoading = (e: boolean): void => {
        this.isLoading = e;
    };
}
